import React, { useState } from "react";
import ReactModal from "react-modal";
import style from "../SendMerchantLink/SendMerchantLink.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import { TextInput } from "../../../../components/form/text-input";
import { updateZohoData } from "../../../../../api";
import toast from "react-hot-toast";

function EditZoho({ open, onClose, appData, getAppData, zohoIdType }) {
  const [zohoId, setZohoId] = useState(
    zohoIdType === "zoho_id" ? appData?.zoho_id : appData?.zoho_submission_id
  );
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { value } = e.target;
    setZohoId(value);
    setError("");
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    setError("");

    const data = {
      id: appData.id,
      [zohoIdType === "zoho_id" ? "zoho_id" : "zoho_submission_id"]: zohoId,
      zohoIdType: zohoIdType === "zoho_id" ? "zoho_id" : "submission_id",
    };

    const toastId = toast.loading("Updating...");
    try {
      const response = await updateZohoData(data);
      
      if (response.status) {
        toast.success("Updated successfully!", { id: toastId });
        getAppData();
        onClose();
      } else {
        toast.error(response.message || "Failed to update", { id: toastId });
        setError(response.message || "Failed to update");
      }
    } catch (err) {
      toast.error("Something went wrong!", { id: toastId });
      setError("Something went wrong!");
    }

    setIsLoading(false);
  };

  return (
    <ReactModal isOpen={open} className={style.react_modal} ariaHideApp={false}>
      <div className={style.header}>
        <ButtonIcon onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.28033 3.21967C3.98744 2.92678 3.51256 2.92678 3.21967 3.21967C2.92678 3.51256 2.92678 3.98744 3.21967 4.28033L6.93934 8L3.21967 11.7197C2.92678 12.0126 2.92678 12.4874 3.21967 12.7803C3.51256 13.0732 3.98744 13.0732 4.28033 12.7803L8 9.06066L11.7197 12.7803C12.0126 13.0732 12.4874 13.0732 12.7803 12.7803C13.0732 12.4874 13.0732 12.0126 12.7803 11.7197L9.06066 8L12.7803 4.28033C13.0732 3.98744 13.0732 3.51256 12.7803 3.21967C12.4874 2.92678 12.0126 2.92678 11.7197 3.21967L8 6.93934L4.28033 3.21967Z"
              fill="#737278"
            />
          </svg>
        </ButtonIcon>
      </div>

      <div className={style.body}>
        <h6>Edit {zohoIdType === "zoho_id" ? "Zoho ID" : "Submission ID"}</h6>

        <div className={style.form_group}>
          <TextInput
            id={zohoIdType}
            name={zohoIdType}
            label={zohoIdType === "zoho_id" ? "Zoho ID" : "Submission ID"}
            value={zohoId || ""}
            onChange={handleChange}
            placeholder={`Enter ${
              zohoIdType === "zoho_id" ? "Zoho ID" : "Submission ID"
            }`}
            errored={!!error}
            error={error}
          />
        </div>
      </div>

      <div className={style.footer_modal}>
        <div className={style.button_group}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#4C70EF"}
            textColor="#FFF"
            isLoading={isLoading}
            disabled={!zohoId}
            onClick={handleSubmit}
          >
            Update
          </ButtonIcon>
        </div>
      </div>
    </ReactModal>
  );
}

export default EditZoho; 